import React, { Component, Suspense } from 'react'
import { MemoryRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Register = React.lazy(() => import('./views/pages/register/Register'))

class App extends Component {
  render() {
    return (
      <MemoryRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </MemoryRouter>
    )
  }
}

export default App
